if (!customElements.get('cart-terms')) {
  class CartTerms extends HTMLElement {
    constructor() {
      super();
      this.cartTermsCheckbox = this.querySelector('.js-cart-terms-checkbox');
      this.form = document.getElementById(this.cartTermsCheckbox.getAttribute('form'));
      this.submitHandler = this.handleSubmit.bind(this);
      this.changeHandler = this.handleChange.bind(this);
      this.form.addEventListener('submit', this.submitHandler);
      this.cartTermsCheckbox.addEventListener('change', this.changeHandler);
      CartTerms.injectStyles();
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.submitHandler);
      this.cartTermsCheckbox.removeEventListener('change', this.changeHandler);
    }

    /**
     * Blocks the cart form submit until the terms checkbox is ticked,
     * surfacing an inline, accessible error instead of a native alert.
     * @param {object} evt - Event object.
     */
    handleSubmit(evt) {
      if (!this.cartTermsCheckbox.checked) {
        evt.preventDefault();
        this.showError();
      }
    }

    /** Clears the error as soon as the shopper ticks the box. */
    handleChange() {
      if (this.cartTermsCheckbox.checked) {
        this.clearError();
      }
    }

    showError() {
      this.classList.add('cart-terms--error');
      if (!this.errorEl) {
        this.errorEl = document.createElement('p');
        this.errorEl.className = 'cart-terms__error';
        this.errorEl.setAttribute('role', 'alert');
        this.errorEl.textContent = theme.strings.cartTermsConfirmation;
        // Anchor after the whole checkbox+label row (when present) so the message drops BELOW it,
        // not beside it inside the flex row. Falls back to label/checkbox on layouts without a row.
        const anchor = this.querySelector('.cart-terms__row') || this.querySelector('label') || this.cartTermsCheckbox;
        anchor.insertAdjacentElement('afterend', this.errorEl);
      }
      try {
        this.cartTermsCheckbox.focus({ preventScroll: false });
      } catch (e) {
        this.cartTermsCheckbox.focus();
      }
    }

    clearError() {
      this.classList.remove('cart-terms--error');
      if (this.errorEl) {
        this.errorEl.remove();
        this.errorEl = null;
      }
    }

    /** Injects the error styles once, so the component works on the drawer and the cart page alike. */
    static injectStyles() {
      if (document.getElementById('cart-terms-styles')) return;
      const style = document.createElement('style');
      style.id = 'cart-terms-styles';
      style.textContent =
        '.cart-terms__error{color:#d11;font-size:0.8em;font-weight:600;line-height:1.35;margin:6px 0 0;}' +
        '.cart-terms--error .js-cart-terms-checkbox{outline:2px solid #d11;outline-offset:2px;}' +
        '.cart-terms--error label{color:#d11;}' +
        '.cart-terms__required{color:#d11;text-decoration:none;font-weight:700;margin-inline-start:2px;}';
      document.head.appendChild(style);
    }
  }
  customElements.define('cart-terms', CartTerms);
}
